import React from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";
import kioskQuizImg from "../../assets/images/kioskQuiz1.jpg";
import kioskQuizImg2 from "../../assets/images/kioskQuiz2.jpg";

const KioskQuiz = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          kioskQuiz
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          <CodeEditorMock>
            Developed a{" "}
            <span class="function-color op-1">
              terminal safety quiz kiosk system
            </span>{" "}
            named <span class="html-color-text op-1">Terminal Safety Quiz</span>
            , designed to{" "}
            <span class="string-color-text op-1">
              collect user information and ensure legal compliance
            </span>{" "}
            through mandatory tests before granting terminal access.
            <br />
            <br />
            Built with <span class="react-color-text op-1">React</span> on the
            frontend and <span class="nodejs-color-text op-1">Express.js</span>{" "}
            on the backend, the system includes{" "}
            <span class="function-color op-1">
              account management for both administrators and users
            </span>{" "}
            and operates with a{" "}
            <span class="docker-color-text op-1">
              membership-based login flow
            </span>
            .
            <br />
            <br />
            After passing the quiz, users can{" "}
            <span class="function-color op-1">
              request terminal access
            </span>{" "}
            without retaking the test for{" "}
            <span class="string-color-text op-1">up to 6 months</span>. Upon
            approval, they receive a{" "}
            <span class="function-color op-1">QR-coded invitation</span> which
            can be scanned at the entrance for quick validation.
            <br />
            <br />
            Integrated a{" "}
            <span class="function-color op-1">cron job scheduler</span> that
            runs daily at <span class="string-color-text op-1">17:00</span> to{" "}
            <span class="docker-color-text op-1">
              automatically send applicant data
            </span>{" "}
            to the terminal's security company. All user and test data is
            securely stored in a{" "}
            <span class="nodejs-color-text op-1">SQL database</span> to ensure
            compliance and auditability.
          </CodeEditorMock>
        </div>
        <div className="right">
          <div className="comment">// Some images from the project</div>
          <img src={kioskQuizImg} alt="Kiosk Quiz" className="project-img" />
          <img src={kioskQuizImg2} alt="Kiosk Quiz" className="project-img" />
          <div className="comment">// Code snippet for getRequestsByDate</div>
          <div className="box-container">
            <CodeEditorMock>
              <span class="const-color">const</span>{" "}
              <span class="function-color">getRequestsByDate</span> ={" "}
              <span class="const-color">async</span> (req, res) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">const</span> {"{"} date{" "}
              {"}"} = req.body; <br />
              <br />
              &nbsp;&nbsp;<span class="const-color">if</span> (!date) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="return-color">
                return
              </span>{" "}
              res.status(
              <span class="number-color-text">400</span>).json({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;success:{" "}
              <span class="boolean-color-text">false</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;message:{" "}
              <span class="string-color-text">
                'Date field is required (YYYY-MM-DD)'
              </span>
              ,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;<span class="const-color">try</span> {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">
                const
              </span>{" "}
              <span class="variable-color">query</span> = `
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="sql-color">SELECT</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.id{" "}
              <span class="sql-color">AS</span> request_id,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="function-color">
                DATE_FORMAT
              </span>(r.request_date,{" "}
              <span class="string-color-text">'%d-%M-%Y'</span>){" "}
              <span class="sql-color">AS</span> request_date,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.request_time,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.object,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.contact_person,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.reason,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.created_date,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r.created_time,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;v.id{" "}
              <span class="sql-color">AS</span> visitor_id,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;v.first_name,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;v.last_name
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="sql-color">FROM</span> Request r
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="sql-color">LEFT JOIN</span> Visitor v{" "}
              <span class="sql-color">ON</span> r.visitor_id = v.id
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="sql-color">WHERE</span> r.created_date = ?
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="sql-color">ORDER BY</span> r.created_time{" "}
              <span class="sql-color">DESC</span>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;`;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">
                const
              </span>{" "}
              [rows] = <span class="const-color">await</span> db.execute(query,
              [date]);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">
                const
              </span>{" "}
              <span class="variable-color">requests</span> = rows.map(row =&gt;
              ({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;id: row.request_id,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;request_date:
              row.request_date,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;object: row.object,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;visitor: {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;id:
              row.visitor_id,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;first_name:
              row.first_name,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;email: row.email,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"}"},
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}));
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;res.status(
              <span class="number-color-text">200</span>
              ).json({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;success:{" "}
              <span class="boolean-color-text">true</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;data: requests,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;{"}"} <span class="const-color">catch</span> (error){" "}
              {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;console.error(
              <span class="string-color-text">'Error fetching requests:'</span>,
              error);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;res.status(
              <span class="number-color-text">500</span>
              ).json({"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;success:{" "}
              <span class="boolean-color-text">false</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;message:{" "}
              <span class="string-color-text">'Failed to fetch requests'</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"});
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              {"}"};
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KioskQuiz;
